import xhr from 'xhr.js';
import auth from 'services/auth';

const service_users = {
    getNotificationSettings: async () => {
        const account_id = auth.getAccountId();
        const res = await xhr.get(`/me/notification-settings?account_id=${account_id}`, {
            withCredentials: true
        });
        return res.data;
    },
    /**
     * @typedef {Object} UpdateNotificationSettingsBody
     * @property {number} screenerFinished
     * @property {number} spotSelected
     */
    /**
     * @typedef {Object} UpdateNotificationSettingsResponse
     * @property {number} id
     * @property {number} user_id
     * @property {number} screener_finished
     * @property {number} spot_selected
     * @property {number} spot_add_to_calendar
     * @property {Record<string, string>} labels
     */
    /**
     * Update notification settings.
     *
     * @param {UpdateNotificationSettingsBody} notificationSettings
     * @returns {Promise<UpdateNotificationSettingsResponse>}
     */
    updateNotificationSettings: async notificationSettings => {
        const account_id = auth.getAccountId();
        const res = await xhr.put(
            `/me/notification-settings`,
            {
                notification_settings: {
                    screener_finished: notificationSettings.screenerFinished,
                    spot_selected: notificationSettings.spotSelected
                }
            },
            {
                withCredentials: true,
                params: {
                    account_id
                }
            }
        );

        return res.data;
    },
    updateUserTimezone: async timezone => {
        const res = await xhr.put(
            `/me/timezone`,
            { timezone },
            {
                withCredentials: true
            }
        );

        return res.data;
    },
    /**
     * Get account preview. Information about account statistics.
     *
     * @returns {{ paid_users: number, allowed_users: number, total_users: number }}
     */
    getAccountUsersSummary: async () => {
        const accountId = auth.getAccountId();
        const response = await xhr.get(`/accounts/${accountId}/users-summary`, {
            withCredentials: true
        });
        return response.data;
    },
    /**
     * @typedef {Object} SubmitProductFeedbackBody
     * @property {string} feedbackTitle - Brief summary of the feedback
     * @property {string} feedbackText - Detailed feedback text
     * @property {string} url - Current page URL (truncated to 255 chars)
     */
    /**
     * Submit product feedback.
     *
     * @param {SubmitProductFeedbackBody} params
     * @returns {Promise<{ message: string }>}
     */
    submitProductFeedback: async ({ feedbackTitle, feedbackText, url }) => {
        const accountId = auth.getAccountId();
        const response = await xhr.post(
            `/product-feedback`,
            {
                feedback_title: feedbackTitle,
                feedback_text: feedbackText,
                url: url.substring(0, 255)
            },
            {
                withCredentials: true,
                params: {
                    account_id: accountId
                }
            }
        );
        return response.data;
    }
};

export default service_users;
